module.exports = __webpack_public_path__ + "img/94.ea4ee4bb.jpg";